// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  envName: 'dev',
  production: false,
  mapsApiKey: 'AIzaSyC21CfGGdO5O-YgfjKiOSBLIr3vQPLVTug',
  uploadsSecureContainer: 'uploadssecure',
  uploadsContainer: 'uploads',
  isDevelopment: true,
  eoc: {
    taskLocationTemplate: 'templates/import_task_location_template.csv',
    emergencyTemplate: 'templates/emergency-upload-template.csv',
    productTemplate: 'templates/products-upload-template.csv',
  },
  activityResponsibility: {
    activityResponsibilityTemplate: 'templates/activity-responsibilities.csv',
  },
  assembler: {
    assemblerTemplate: 'templates/assembler.csv',
  },
  inventoryNotifications: {
    inventoryNotificationTemplate: 'templates/inventory-notifications.csv',
  },
  locations: {
    allowedFeatures: 'templates/location-allowed-features.csv',
  },
};
